import { $themeBreakpoints } from '@themeConfig'

export default {
  watch: {
    $route() {
      if (this.$appConfig < $themeBreakpoints.xl) {
        this.isVerticalMenuActive = false
      }
    },
  },
}
